import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogImage, getDialogImageFileName } from "src/app/data/dialog-image";

@Component({
  selector: "app-dialog-alert",
  templateUrl: "./dialog-alert.component.html",
  styleUrls: ["./dialog-alert.component.scss"],
})
export class DialogAlertComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    this.text = data.text;
    this.excessiveAmount = data.excessiveAmount
    if (data.dialogImage != null) {
      this.showIdentityButton = data.dialogImage == DialogImage.USER_CREATED;

      this.dialogImageUrl = `../../../assets/image/${getDialogImageFileName(
        data.dialogImage

      )}`;
    }

    this.success = data.success;
    this.translatable = data.translatable
    this.iconUrl = this.success ? this.successUrl : this.errorUrl;
  }
  showIdentityButton = false;
  errorUrl = "../../../assets/icons/ic_error.svg";
  successUrl = "../../../assets/icons/ic_check.svg";
  dialogImageUrl;
  text;
  success: boolean;
  iconUrl;
  excessiveAmount = false
  translatable = true
  ngOnInit(): void {}
}
